import { List, arrayMove } from 'react-movable'
import { showTransformItem } from '../helpers/configAppPageHelper'

const ReorderItems = ({ items, setItems, type }) => {
  const handleChange = ({ oldIndex, newIndex }) => {
    const newArrayOrder = arrayMove(items, oldIndex, newIndex)
    setItems(newArrayOrder)
  }

  return (
    <List
      lockVertically
      values={items}
      onChange={({ oldIndex, newIndex }) =>
        handleChange({ oldIndex, newIndex })
      }
      renderList={({ children, props, isDragged }) => (
        <div
          {...props}
          style={{ padding: 0, cursor: isDragged ? 'grabbing' : undefined }}
        >
          {children}
        </div>
      )}
      renderItem={({ value, props, isDragged, isSelected }) => (
        <div
          {...props}
          key={props.key}
          className="bg-lightblue py-3 pr-3 pl-2 rounded rounded-5 text-center my-3"
          style={{
            ...props.style,
            zIndex: 9999999999999,
            cursor: isDragged ? 'grabbing' : 'grab',
            backgroundColor: isDragged || isSelected ? '#EEE' : '#FFF',
          }}
        >
          <div className="d-flex align-content-center align-items-center">
            <div className="flex-grow-0 mr-2">
              <i className="fas fa-arrows-alt fa-2x" />
            </div>
            <div className="flex-grow-1">
              {type === 'all' && showTransformItem(value.itemMain)}
              {type === 'sub1' && showTransformItem(value)}
            </div>
          </div>
        </div>
      )}
    />
  )
}

export default ReorderItems
